import React, { useCallback, useContext, useMemo } from 'react';
import ToastContext from '../../contexts/ToastContext';
import AccountPickerContext from '../../contexts/AccountPickerContext';
import CurrentUserContext from '../../contexts/CurrentUserContext';
import RolesContext from '../../contexts/RolesContext';
import { UIVersionContext } from '../../contextProviders/SplashScreenProviders/UserAndAccountProviders/UIVersionProvider';
import PERMISSIONS from '../../permissionDefinitions';
import getTimeStamp from '../../getTimeStamp';
import STORE from '../../store';
import { Option } from '../../kingpin/atoms/ContextMenu';

const V3UnpublishReport = ({ report }: { report: ReportType }) => {
  const { showToast } = useContext(ToastContext);
  const { selectedAccountId } = useContext(AccountPickerContext);
  const { id: currentUserId } = useContext(CurrentUserContext);
  const { currentPermissions } = useContext(RolesContext);
  const { isV3 } = useContext(UIVersionContext);

  const isOptionAvailable = useMemo(() => {
    if (!isV3) {
      return false;
    }

    if (!report.isV3Published) {
      return false;
    }

    if (
      currentPermissions.includes(
        PERMISSIONS.CONTENT_ACCESS.SET_ANY_AVAILABLE_TO_PRIVATE,
      )
    ) {
      return true;
    }

    if (currentUserId === report.createdBy) {
      return true;
    }

    return false;
  }, [
    currentPermissions,
    currentUserId,
    isV3,
    report.createdBy,
    report.isV3Published,
  ]);

  const onUnpublishClicked = useCallback(() => {
    const newReport: ReportType = {
      ...report,
      isV3Published: false,
      updatedBy: currentUserId,
      updatedOn: getTimeStamp(),
    };

    STORE.getReportsRef({
      accountId: selectedAccountId,
    })
      .doc(report.id)
      .set(newReport)
      .then(() => {
        showToast(`"${report.name}" has been unpublished successfully!`);
      });
  }, [currentUserId, report, selectedAccountId, showToast]);

  if (!isOptionAvailable) {
    return null;
  }

  return <Option label={'Unpublish'} onClick={onUnpublishClicked} />;
};

export default V3UnpublishReport;
